const moduleName = 'AUTH_ACTIONS';

const AUTH_ACTIONS = {
    ME: `${moduleName}_ME`,
    ME_OK: `${moduleName}_ME_OK`,
    ME_ERROR: `${moduleName}_ME_ERROR`,
    ME_RESET: `${moduleName}_ME_RESET`,

    LOGIN: `${moduleName}_LOGIN`,
    LOGIN_OK: `${moduleName}_LOGIN_OK`,
    LOGIN_ERROR: `${moduleName}_LOGIN_ERROR`,
    LOGIN_RESET: `${moduleName}_LOGIN_RESET`,

    LOGOUT: `${moduleName}_LOGOUT`,
    LOGOUT_OK: `${moduleName}_LOGOUT_OK`,
    LOGOUT_ERROR: `${moduleName}_LOGOUT_ERROR`,
    LOGOUT_RESET: `${moduleName}_LOGOUT_RESET`,

    REFRESH_TOKEN: `${moduleName}_REFRESH_TOKEN`,
    REFRESH_TOKEN_OK: `${moduleName}_REFRESH_TOKEN_OK`,
    REFRESH_TOKEN_ERROR: `${moduleName}_REFRESH_TOKEN_ERROR`,

    TOKEN_LOADED: `${moduleName}_TOKEN_LOADED`,
    LOAD_INSPECTION_REPORT: `${moduleName}_LOAD_INSPECTION_REPORT`,
    LOAD_INSPECTION_REPORT_OK: `${moduleName}_LOAD_INSPECTION_REPORT_OK`,
    LOAD_INSPECTION_REPORT_ERROR: `${moduleName}_LOAD_INSPECTION_REPORT_ERROR`,
    LOAD_INSPECTION_REPORT_RESET: `${moduleName}_LOAD_INSPECTION_REPORT_RESET`,
};
export default AUTH_ACTIONS;



// WEBPACK FOOTER //
// ./src/constants/actions/auth.js